export default __webpack_public_path__ + "static/media/Background.4939bc2a.png";